import http from "../../helpers/http";
import httpBlob from "../../helpers/http-blob";
import * as helpers from "../../helpers/helpers";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_PROFILE_SETTINGS,
  FETCH_PROFILE_SETTINGS_SUCCESS,
  FETCH_PROFILE_SETTINGS_FAILED,
  SAVE_PROFILE_SETTINGS,
  SAVE_PROFILE_SETTINGS_SUCCESS,
  SAVE_PROFILE_SETTINGS_FAILED,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILED,
} from "./actionTypes";
import { getAuthUserToken } from "../../helpers/authToken";

export const fetchProfileSettings = () => (dispatch) => {
  dispatch({
    type: FETCH_PROFILE_SETTINGS,
    payload: null,
  });
  http
    .post(
      "user/profile-settings",
      helpers.doObjToFormData({ token: getAuthUserToken() }),
    )
    .then(({ data }) => {
      dispatch({
        type: FETCH_PROFILE_SETTINGS_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_PROFILE_SETTINGS_FAILED,
        payload: error,
      });
      const { data } = error.response;
      localStorage.removeItem("authToken");
      window.location.reload();
    });
};

export const saveProfileSettingsAction = (formData) => (dispatch) => {
  formData = { ...formData, token: getAuthUserToken() };
  let file = formData.profile;
  delete formData.profile;
  formData.receive_email_notifications = formData.receive_email_notifications ? 1 : 0;
  formData = helpers.doObjToFormData(formData);
  if (typeof file != "undefined") formData.append("profile", file[0]);
  dispatch({
    type: SAVE_PROFILE_SETTINGS,
    payload: null,
  });
  httpBlob
    .post("user/save-profile-settings-testing", formData)
    .then(({ data }) => {
      if (data.status) {
        toast.success("Profile settings saved successfully.", TOAST_SETTINGS);
        dispatch({
          type: SAVE_PROFILE_SETTINGS_SUCCESS,
          payload: data,
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        if (data.validationErrors) {
          toast.error(
            <Text string={data.validationErrors} parse={true} />,
            TOAST_SETTINGS,
          );
          dispatch({
            type: SAVE_PROFILE_SETTINGS_FAILED,
            payload: null,
          });
        }
      }
    })
    .catch((error) => {
      dispatch({
        type: SAVE_PROFILE_SETTINGS_FAILED,
        payload: error,
      });
      const { data } = error.response;
      localStorage.removeItem("authToken");
      window.location.reload();
    });
};

export const changePasswordAction = (formData) => (dispatch) => {
  formData = { ...formData, token: getAuthUserToken() };
  dispatch({
    type: CHANGE_PASSWORD,
    payload: null,
  });
  http
    .post("user/change-password", helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        toast.success("Password changed successfully.", TOAST_SETTINGS);
        dispatch({
          type: CHANGE_PASSWORD_SUCCESS,
          payload: data,
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        if (data.validationErrors) {
          toast.error(
            <Text string={data.validationErrors} parse={true} />,
            TOAST_SETTINGS,
          );
          dispatch({
            type: CHANGE_PASSWORD_FAILED,
            payload: null,
          });
        }
      }
    })
    .catch((error) => {
      dispatch({
        type: CHANGE_PASSWORD_FAILED,
        payload: error,
      });
      const { data } = error.response;
      localStorage.removeItem("authToken");
      window.location.reload();
    });
};
